import { FulfilmentMethod } from '@thg-commerce/enterprise-graphql/aurora-schema'
import { InStockLocation } from '../../generated/graphql'
import { ProductVariant } from '@thg-commerce/enterprise-aurora-landing/horizon-schema'

export enum WeightGroupsType {
  OneMan = '1-Man',
  OutOfGauge = 'out-of-gauge',
  VendorDirect = 'vendor-direct',
}

export const fulfilmentMethod = (product: {
  weightGroups?: string[] | null
  inStockLocations?: InStockLocation[] | string[] | null
  leadTime?: number | null
  isBookable?: boolean | null
  isCheckStock?: boolean | null
  isNoCheckStock?: boolean | null
  isOrderInStore?: boolean | null
  eligibleForFulfilmentMethods?: FulfilmentMethod[] | string[] | null
  variants: ProductVariant[]
}) => {
  const outOfGauge = product.weightGroups?.includes(WeightGroupsType.OutOfGauge)
  const homeDelivery = Boolean(
    product?.eligibleForFulfilmentMethods?.includes(
      FulfilmentMethod.HomeDelivery,
    ),
  )

  const storeAvailable = Boolean(
    product?.eligibleForFulfilmentMethods?.includes(
      FulfilmentMethod.CollectInStore,
    ),
  )

  const storeDelivery = Boolean(
    product.eligibleForFulfilmentMethods?.includes(
      FulfilmentMethod.DeliverToStore,
    ),
  )

  const eligibleForHomeDelivery =
    homeDelivery &&
    product.inStockLocations?.includes(InStockLocation.Warehouse)
      ? true
      : false

  const eligibleForDatedDelivery =
    product.leadTime &&
    product.weightGroups?.includes(WeightGroupsType.VendorDirect)
      ? true
      : false

  const eligibleForNextDayDelivery =
    (outOfGauge || product.weightGroups?.includes(WeightGroupsType.OneMan)) &&
    product.isBookable

  const storeDeliveryEnabled =
    storeAvailable ||
    product.isCheckStock ||
    product.isOrderInStore ||
    product.isNoCheckStock

  const isCheckStock =
    product.variants.some((variant) => variant.isCheckStock) ?? null

  const canProductBeStockedChecked =
    product.variants.some((variant) => variant.isNoCheckStock) ?? null

  return {
    outOfGauge: outOfGauge ?? false,
    eligibleForHomeDelivery: eligibleForHomeDelivery ?? false,
    eligibleForDatedDelivery: eligibleForDatedDelivery ?? false,
    eligibleForNextDayDelivery: eligibleForNextDayDelivery ?? false,
    storeDeliveryEnabled: storeDeliveryEnabled ?? false,
    isCheckStock: isCheckStock ?? false,
    canProductBeStockedChecked: canProductBeStockedChecked ?? false,
    icons: {
      homeDelivery: homeDelivery ?? false,
      // @TODO CSBOM-474 update storeAvailable to storeCollection everywhere it is used
      storeAvailable: storeAvailable ?? false,
      storeDelivery: storeDelivery ?? false,
      __typename: 'Icons',
    },
    weightGroups: product.weightGroups || [],
    isBookable: product.isBookable ?? false,
    isOrderInStore: product.isOrderInStore ?? false,
    inStockLocations: product.inStockLocations,
    leadTime: product.leadTime,
  }
}
